export const CUSTOM_ARTIFACT_TYPE = 'custom'

export const DE_ARTIFACT_TYPE_LABELS = {
  dsfinvk: 'DSFinV-K',
  tse_tar: 'TSE-TAR',
  procedure_doc: 'Verfahrensdoku',
  cash_register_data: 'Belegdaten / Kassendaten',
  [CUSTOM_ARTIFACT_TYPE]: 'Benutzerdefiniert'
}

export const customArtifactLabel = (artifactType, label) => (
  artifactType === CUSTOM_ARTIFACT_TYPE ? String(label || '').trim() : ''
)

export const hasRequiredArtifactDescription = (artifactType, label) => (
  artifactType !== CUSTOM_ARTIFACT_TYPE || Boolean(customArtifactLabel(artifactType, label))
)
